import { render, staticRenderFns } from "./AboutFilmDurango.vue?vue&type=template&id=21feacde&scoped=true&"
import script from "./AboutFilmDurango.vue?vue&type=script&lang=js&"
export * from "./AboutFilmDurango.vue?vue&type=script&lang=js&"
import style0 from "./AboutFilmDurango.vue?vue&type=style&index=0&id=21feacde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21feacde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VImg,VPagination,VRow})
